"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirestoreClient = void 0;
var app_1 = require("firebase/app");
require("firebase/firestore");
var FirestoreClient = /** @class */ (function () {
    function FirestoreClient(options) {
        this.firebaseAppInstance = app_1.default.initializeApp(options.firebase, options.projectName);
        this.firestore = app_1.default.firestore(this.firebaseAppInstance);
        this.organizationId = options.organizationId;
    }
    Object.defineProperty(FirestoreClient.prototype, "projectName", {
        get: function () {
            return this.firebaseAppInstance.name;
        },
        enumerable: false,
        configurable: true
    });
    FirestoreClient.prototype.subscribeToEntityChange = function (entityType, entityId, subscriptionCallback, skipInitialCallback) {
        if (skipInitialCallback === void 0) { skipInitialCallback = true; }
        var callback = this.getOnSnapshotCallback(subscriptionCallback, skipInitialCallback);
        return this.firestore
            .collection("organisations")
            .doc(this.organizationId)
            .collection(entityType)
            .doc(entityId)
            .onSnapshot(callback);
    };
    FirestoreClient.prototype.subscribeToCollectionChange = function (entityType, subscriptionCallback, skipInitialCallback) {
        if (skipInitialCallback === void 0) { skipInitialCallback = true; }
        var callback = this.getOnSnapshotCallback(subscriptionCallback, skipInitialCallback);
        return this.firestore
            .collection("organisations")
            .doc(this.organizationId)
            .collection(entityType)
            .onSnapshot(callback);
    };
    FirestoreClient.prototype.unsubscribeFromEntityChange = function (entityType, entityId) {
        var unsubscribe = this.firestore
            .collection("organisations")
            .doc(this.organizationId)
            .collection(entityType)
            .doc(entityId)
            .onSnapshot(function () { return null; });
        unsubscribe();
    };
    FirestoreClient.prototype.unsubscribeFromCollectionChange = function (entityType) {
        var unsubscribe = this.firestore
            .collection("organisations")
            .doc(this.organizationId)
            .collection(entityType)
            .onSnapshot(function () { return null; });
        unsubscribe();
    };
    FirestoreClient.prototype.isPurged = function () {
        var _this = this;
        return app_1.default.apps.findIndex(function (app) { return app.name === _this.firebaseAppInstance.name; }) === -1;
    };
    FirestoreClient.prototype.purge = function () {
        return this.firebaseAppInstance.delete();
    };
    FirestoreClient.prototype.getOnSnapshotCallback = function (callbackFunction, skipInitialCallback) {
        /**
         * This skipInitialCallback is needed because .onSnapshot() is not just subscribing to firestore document
         * update, it's calling the callback first time right after you invoked .onSnapshot() with the current state of
         * the document. We want to be able to skip that initial call, just subscribe to future updates
         */
        return skipInitialCallback
            ? (function () {
                var isInitialCall = true;
                return function (snapshot) {
                    if (isInitialCall) {
                        isInitialCall = false;
                        return;
                    }
                    return callbackFunction(snapshot);
                };
            })()
            : callbackFunction;
    };
    return FirestoreClient;
}());
exports.FirestoreClient = FirestoreClient;
//# sourceMappingURL=FirestoreClient.js.map